// extracted by mini-css-extract-plugin
export default {"list-item":"listItem_list-item__CHTKx","up-down":"listItem_up-down__R58Rh"};